import { render } from "./CustomAudienceManagement.vue?vue&type=template&id=fff4f73a&scoped=true"
import script from "./CustomAudienceManagement.vue?vue&type=script&lang=js"
export * from "./CustomAudienceManagement.vue?vue&type=script&lang=js"

import "./CustomAudienceManagement.vue?vue&type=style&index=0&id=fff4f73a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff4f73a"]])

export default __exports__